import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError, AxiosResponse } from "axios";
import { RootState } from "../store";
import axiosInstance from "src/apis/axiosInstance";
import {
  APIResponseCover,
  Pagination,
  PartnerAPIResponseCover,
} from "./auth.d";
import { readAPIErrorMessage, throwErrApi } from "src/utils/errorUtil";
import { API_STATUS, DATA_LIMIT, GainMargin } from "src/utils/constants";
import { UserData } from "./users";

// export interface UserViewData {
//   uuid: string;
// }

// export interface UserEditDataForm {
//   uuid: string;
//   role: string;
//   first_name: string;
//   last_name: string;
//   country_code: string;
//   mobile_number: string;
//   email: string;
//   city: string;
// }

export enum TransactionType {
  "Inwards" = 1,
  "OutWards",
}

export enum PartnerType {
  "Agent" = 1,
  "Cab vendor",
  "Driver",
  "Hotel",
  "Taxi",
}

export interface BookingTransactForm {
  amount: string;
  transaction_type?: TransactionType;
  // partner_type?: PartnerType;
  agent?: string;
  driver?: string;
  taxi?: string;
  booking_hotel?: string; // hotel
  booking_cabvendor?: string; //cabvendor
  booking_flight?: string; // airline
  booking_cruise?: string; // cruise line
  booking_visa?: string; // visa
  booking_insurance?: string; // insurance
  booking_id: string;
  notes: string;
}

export interface BookingHotelForm {
  // id: string;
  // hotel_id: string;
  hotel: string;
  hotel_booking_reference: string;
  no_of_rooms: string;
  room_category: string;
  checkin_date: string;
  checkout_date: string;
  hotel_price: string;
  price_per_room: string;
  billing_mode: string;
  advance_amount_paid: string;
  payment_notification_date: string | null;
  booking: string;
  meal_plan: string;
  notes: string;
}

export interface BookingHotelEditForm extends BookingHotelForm {
  id: string;
}

export interface BookingCabForm {
  // id: string;
  driver: string;
  cab_vendor: string;
  arrival_place: string;
  arrival_time: string;
  vehicle_number: string;
  vehicle_type: string;

  cab_price: string;
  other_cab_expenses: string;
  trip_details: string;
  opening_kms: string;
  closing_kms: string;
  // travel_agent: string;
  booking: string;
  dropping_place: string;
  taxi: string;
}
export interface BookingCabEditForm extends BookingCabForm {
  id: string;
}

export interface BookingDataEditForm {
  id: string;
  agent_commission: string | null;
  amount_received: string | null;
  arrival_date: string;
  customer_name: string;
  customer_number: string;
  email: string | null;
  departure_date: string;
  flight_tickets: string | null;
  next_payment_date: string | null;
  // profit: string;
  total_pax: string | null;
  total_children: string | null;
  total_amount: string;
  travel_agent_id: string;
  customer_address: string;
  customer_gstn: string;
  notes: string;
  status?: BOOKING_STATUS | "";
}

// : Array<
//   keyof Pick<
//   BookingDataForm,
//   | "agent_commission"
//   | "amount_received"
//   | "email"
//   | "flight_tickets"
//   | "next_payment_date"
//   | "total_pax"
//   | "total_children"
// >
// >
export const nullValueKeysBooking = [
  "agent_commission",
  "amount_received",
  "email",
  "flight_tickets",
  "next_payment_date",
  "total_pax",
  "total_children",
] as const;

export interface BookingDataForm {
  // CAB
  // arrival_place: string;
  // arrival_time: string;
  // driver_id: string;
  // cab_price: string;
  // other_cab_expenses: string;
  // vehicle_type: string;
  // vehicle_number: string;
  // trip_details: string;

  // HOTEL
  // hotel: string;
  // room_category: string;
  // checkin_date: string;
  // check_out_date: string;
  // hotel_price: string;
  // advance_amount_paid: string;
  // payment_notification_date: string;

  agent_commission: string | null;
  amount_received: string | null;
  arrival_date: string;
  customer_name: string;
  customer_number: string;
  email: string | null;
  departure_date: string;
  flight_tickets: string | null;
  next_payment_date: string | null;
  // profit: string;
  total_pax: string | null;
  total_children: string | null;
  total_amount: string;
  travel_agent_id: string;
  customer_address: string;
  customer_gstn: string;
  notes: string;
}

export interface CabVendor {
  id: string;
  contact_person_name: string;
  email_id: string;
  company_name: string;
  city: any;
  contact_number: string;
  alternate_number: string;
  notes: string;
  status: number;
  created_date: string;
  updated_date: string;
  company: string;
  user: string;
}

export interface Taxi {
  id: string;
  vehicle_number: string;
  vehicle_name: string;
  notes: string;
  status: number;
  created_date: string;
  updated_date: string;
  company: string;
  user: string;
  agent: string;
}

export interface Driver {
  id: string;
  name: string;
  city: string;
  driver_license_number: string;
  contact_number: string;
  alternate_number: string;
  cab_number: string;
  rating: number;
  notes: string;
  status: number;
  created_date: string;
  updated_date: string;
  company: string;
  user: string;
  cab_vendor: string;
}

export interface Hotel {
  id: string;
  name: string;
  address: string;
  city: string;
  category: number;
  contact_number: string;
  notes: any;
  email_id: string;
  contact_person_name: string;
  reservation_contact_number: string;
  account_details: string;
  status: number;
  created_date: string;
  updated_date: string;
  company: string;
  user: string;
}

export interface TravelAgent {
  id: string;
  name: string;
  company_name: string;
  address: string;
  city: string;
  contact_number: string;
  email_id: string;
  alternate_number: string;
  employees_size: string;
  notes: string;
  status: number;
  created_date: string;
  updated_date: string;
  company: string;
  user: string;
}

export interface BookingCab {
  id: string;
  // driver_id: string;
  arrival_place: string;
  dropping_place: string;
  arrival_time: string;
  dropping_time: string;
  advance_amount_paid: string;
  cab_price: string;
  other_cab_expenses: string;
  vehicle_number: string;
  vehicle_type: string;
  trip_details: string;
  opening_kms: string;
  closing_kms: string;
  // cab_vendor_id: string;
  // created: string;
  // updated: string;
  // booking: string;
  // taxi_id: string;
  cab_vendor?: CabVendor;
  taxi?: Taxi;
  driver?: Driver;
}

export interface BookingHotel {
  id: string;
  hotel: Hotel;
  // hotel_id: string;
  no_of_rooms: string;
  room_category: string;
  checkin_date: string;
  checkout_date: string;
  hotel_price: string;
  price_per_room: string;
  billing_mode: string;
  advance_amount_paid: string;
  payment_notification_date: string | null;
  meal_plan: string;
  notes: string;
  created: string;
  updated: string;
  booking: string;
  hotel_booking_reference?: string;
}

export interface Airline {
  id: string;
  airline_name: string;
  airline_code: string;
  contact_number: string;
  contact_person_name: string;
  email_id: string;
  status: number;
  created_date: string;
  updated_date: string;
}

export interface AirlineRef {
  id: number;
  name: string;
  iata_code: string;
}

export interface BookingFlightForm {
  airline_name: string;
  flight_number: string;
  departure_airport: string;
  arrival_airport: string;
  departure_datetime: string;
  arrival_datetime: string;
  flight_class: string;
  fare: string;
  company_fare: string;
  pnr_number: string;
  flight_status: number;
  advance_amount_paid: string;
  payment_notification_date: string;
  additional_notes: string;
  gst: string;
  booking: string;
  travel_agent?: string | null;
}

export interface BookingFlightEditForm {
  id: string;
  airline_name?: string;
  flight_number?: string;
  departure_airport?: string;
  arrival_airport?: string;
  departure_datetime?: string;
  arrival_datetime?: string;
  flight_class?: string;
  fare?: string;
  company_fare?: string;
  pnr_number?: string;
  flight_status?: number;
  advance_amount_paid?: string;
  payment_notification_date?: string;
  additional_notes?: string;
  gst?: string;
  booking?: string;
  travel_agent?: string | null;
}

export interface BookingFlight {
  id: string;
  airline_name: string | null;
  flight_number: string;
  departure_airport: string;
  arrival_airport: string;
  departure_datetime: string;
  arrival_datetime: string;
  flight_class: string;
  fare: string;
  company_fare: string;
  pnr_number: string;
  flight_status: number;
  advance_amount_paid: string;
  payment_notification_date: string | null;
  additional_notes: string | null;
  gst: string | null;
  created: string;
  updated: string;
  booking: string;
  travel_agent?: { id: string; name: string } | null;
}

export enum BOOKING_STATUS {
  COMPLETED,
  UPCOMING,
  "IN PROGRESS",
  CANCELLED,
  POSTPONED,
}

export enum BOOKING_STATUS_LABEL {
  "Completed",
  "Upcoming",
  "In Progress",
  "Cancelled",
  "Postponed",
}

export enum BOOKING_STATUS_LABEL_COLOR {
  "var(--secondary)",
  "var(--primary)",
  "#3AC977",
  "var(--danger)",
  "var(--warning)",
}

export const FLIGHT_STATUS_LABEL: Record<number, string> = {
  1: "Confirmed",
  2: "Cancelled",
  3: "Pending",
  4: "Rescheduled",
};

export const INSURANCE_TYPE_LABEL: Record<number, string> = {
  1: "Domestic Travel Insurance",
  2: "International Travel Insurance",
  3: "Medical & Emergency Insurance",
  4: "Trip Cancellation",
  5: "Baggage & Personal Belongings Insurance",
  6: "Personal Accident Insurance",
  7: "Travel Delay / Missed Connection Cover",
  8: "Passport Loss Cover",
  9: "Adventure / Sports Travel Insurance",
  10: "Student Travel Insurance",
  11: "Senior Citizen Travel Insurance",
};

export interface CruiseLine {
  id: string;
  cruise_line_name: string;
  cruise_line_code: string;
  contact_number: string;
  contact_person_name: string;
  email_id: string;
  status: number;
  created_date: string;
  updated_date: string;
}

export interface CruisePassenger {
  name: string;
  passport: string;
  contact: string;
}

export interface BookingCruiseForm {
  cruise_line: string;
  ship_name: string;
  departure_port: string;
  arrival_port: string;
  departure_datetime: string;
  arrival_datetime: string;
  cabin_type: string;
  deck_number: string;
  cabin_number: string;
  passengers: CruisePassenger[];
  fare: string;
  currency: string;
  shore_excursions: string;
  advance_amount_paid: string;
  status: number;
  booking: string;
}

export interface BookingCruiseEditForm extends BookingCruiseForm {
  id: string;
}

export interface BookingCruise {
  id: string;
  cruise_line: CruiseLine;
  ship_name: string;
  departure_port: string;
  arrival_port: string;
  departure_datetime: string;
  arrival_datetime: string;
  cabin_type: string;
  deck_number: string;
  cabin_number: string;
  passengers: CruisePassenger[];
  fare: string;
  currency: string;
  shore_excursions: string;
  advance_amount_paid: string;
  status: number;
  created: string;
  updated: string;
  booking: string;
}

export const CRUISE_STATUS_LABEL: Record<number, string> = {
  1: "Confirmed",
  2: "Cancelled",
  3: "Pending",
  4: "Rescheduled",
};

export const PASSPORT_TYPE_LABEL: Record<number, string> = {
  1: "Ordinary",
  2: "Official",
  3: "Diplomatic",
  4: "Emergency",
  5: "Refugee",
  6: "Stateless",
  7: "Collective",
  8: "Special",
};

export interface BookingPassportForm {
  passport_number: string;
  fullname: string;
  nationality: string;
  date_of_birth: string;
  issue_date: string;
  expiry_date: string;
  issue_country: string;
  place_of_issue: string;
  passport_type: number;
  notes: string;
  booking: string;
}

export interface BookingPassportEditForm extends BookingPassportForm {
  id: string;
}

export interface BookingPassport {
  id: string;
  passport_number: string;
  fullname: string;
  nationality: string;
  date_of_birth: string;
  issue_date: string;
  expiry_date: string;
  issue_country: string;
  place_of_issue: string;
  passport_type: number;
  notes: string;
  attachments: Record<string, string>;
  created: string;
  updated: string;
  booking: string;
}

export const VISA_TYPE_LABEL: Record<number, string> = {
  1: "Tourist",
  2: "Business",
  3: "Student",
  4: "Work",
  5: "Transit",
  6: "Family",
  7: "Medical",
  8: "Immigrant",
  9: "E-Visa",
  10: "Visa on Arrival",
  11: "Diplomatic",
  12: "Special Category",
};

export const COUNTRY_LIST: { iso_alpha2: string; country_name: string }[] = [
  { iso_alpha2: "AF", country_name: "Afghanistan" },
  { iso_alpha2: "AL", country_name: "Albania" },
  { iso_alpha2: "DZ", country_name: "Algeria" },
  { iso_alpha2: "AD", country_name: "Andorra" },
  { iso_alpha2: "AO", country_name: "Angola" },
  { iso_alpha2: "AG", country_name: "Antigua and Barbuda" },
  { iso_alpha2: "AR", country_name: "Argentina" },
  { iso_alpha2: "AM", country_name: "Armenia" },
  { iso_alpha2: "AU", country_name: "Australia" },
  { iso_alpha2: "AT", country_name: "Austria" },
  { iso_alpha2: "AZ", country_name: "Azerbaijan" },
  { iso_alpha2: "BS", country_name: "Bahamas" },
  { iso_alpha2: "BH", country_name: "Bahrain" },
  { iso_alpha2: "BD", country_name: "Bangladesh" },
  { iso_alpha2: "BB", country_name: "Barbados" },
  { iso_alpha2: "BY", country_name: "Belarus" },
  { iso_alpha2: "BE", country_name: "Belgium" },
  { iso_alpha2: "BZ", country_name: "Belize" },
  { iso_alpha2: "BJ", country_name: "Benin" },
  { iso_alpha2: "BT", country_name: "Bhutan" },
  { iso_alpha2: "BO", country_name: "Bolivia" },
  { iso_alpha2: "BA", country_name: "Bosnia and Herzegovina" },
  { iso_alpha2: "BW", country_name: "Botswana" },
  { iso_alpha2: "BR", country_name: "Brazil" },
  { iso_alpha2: "BN", country_name: "Brunei" },
  { iso_alpha2: "BG", country_name: "Bulgaria" },
  { iso_alpha2: "BF", country_name: "Burkina Faso" },
  { iso_alpha2: "BI", country_name: "Burundi" },
  { iso_alpha2: "KH", country_name: "Cambodia" },
  { iso_alpha2: "CM", country_name: "Cameroon" },
  { iso_alpha2: "CA", country_name: "Canada" },
  { iso_alpha2: "CV", country_name: "Cape Verde" },
  { iso_alpha2: "CF", country_name: "Central African Republic" },
  { iso_alpha2: "TD", country_name: "Chad" },
  { iso_alpha2: "CL", country_name: "Chile" },
  { iso_alpha2: "CN", country_name: "China" },
  { iso_alpha2: "CO", country_name: "Colombia" },
  { iso_alpha2: "KM", country_name: "Comoros" },
  { iso_alpha2: "CG", country_name: "Congo" },
  { iso_alpha2: "CD", country_name: "Congo (DRC)" },
  { iso_alpha2: "CR", country_name: "Costa Rica" },
  { iso_alpha2: "HR", country_name: "Croatia" },
  { iso_alpha2: "CU", country_name: "Cuba" },
  { iso_alpha2: "CY", country_name: "Cyprus" },
  { iso_alpha2: "CZ", country_name: "Czech Republic" },
  { iso_alpha2: "DK", country_name: "Denmark" },
  { iso_alpha2: "DJ", country_name: "Djibouti" },
  { iso_alpha2: "DM", country_name: "Dominica" },
  { iso_alpha2: "DO", country_name: "Dominican Republic" },
  { iso_alpha2: "EC", country_name: "Ecuador" },
  { iso_alpha2: "EG", country_name: "Egypt" },
  { iso_alpha2: "SV", country_name: "El Salvador" },
  { iso_alpha2: "GQ", country_name: "Equatorial Guinea" },
  { iso_alpha2: "ER", country_name: "Eritrea" },
  { iso_alpha2: "EE", country_name: "Estonia" },
  { iso_alpha2: "ET", country_name: "Ethiopia" },
  { iso_alpha2: "FJ", country_name: "Fiji" },
  { iso_alpha2: "FI", country_name: "Finland" },
  { iso_alpha2: "FR", country_name: "France" },
  { iso_alpha2: "GA", country_name: "Gabon" },
  { iso_alpha2: "GM", country_name: "Gambia" },
  { iso_alpha2: "GE", country_name: "Georgia" },
  { iso_alpha2: "DE", country_name: "Germany" },
  { iso_alpha2: "GH", country_name: "Ghana" },
  { iso_alpha2: "GR", country_name: "Greece" },
  { iso_alpha2: "GD", country_name: "Grenada" },
  { iso_alpha2: "GT", country_name: "Guatemala" },
  { iso_alpha2: "GN", country_name: "Guinea" },
  { iso_alpha2: "GW", country_name: "Guinea-Bissau" },
  { iso_alpha2: "GY", country_name: "Guyana" },
  { iso_alpha2: "HT", country_name: "Haiti" },
  { iso_alpha2: "HN", country_name: "Honduras" },
  { iso_alpha2: "HU", country_name: "Hungary" },
  { iso_alpha2: "IS", country_name: "Iceland" },
  { iso_alpha2: "IN", country_name: "India" },
  { iso_alpha2: "ID", country_name: "Indonesia" },
  { iso_alpha2: "IR", country_name: "Iran" },
  { iso_alpha2: "IQ", country_name: "Iraq" },
  { iso_alpha2: "IE", country_name: "Ireland" },
  { iso_alpha2: "IL", country_name: "Israel" },
  { iso_alpha2: "IT", country_name: "Italy" },
  { iso_alpha2: "JM", country_name: "Jamaica" },
  { iso_alpha2: "JP", country_name: "Japan" },
  { iso_alpha2: "JO", country_name: "Jordan" },
  { iso_alpha2: "KZ", country_name: "Kazakhstan" },
  { iso_alpha2: "KE", country_name: "Kenya" },
  { iso_alpha2: "KI", country_name: "Kiribati" },
  { iso_alpha2: "KW", country_name: "Kuwait" },
  { iso_alpha2: "KG", country_name: "Kyrgyzstan" },
  { iso_alpha2: "LA", country_name: "Laos" },
  { iso_alpha2: "LV", country_name: "Latvia" },
  { iso_alpha2: "LB", country_name: "Lebanon" },
  { iso_alpha2: "LS", country_name: "Lesotho" },
  { iso_alpha2: "LR", country_name: "Liberia" },
  { iso_alpha2: "LY", country_name: "Libya" },
  { iso_alpha2: "LI", country_name: "Liechtenstein" },
  { iso_alpha2: "LT", country_name: "Lithuania" },
  { iso_alpha2: "LU", country_name: "Luxembourg" },
  { iso_alpha2: "MG", country_name: "Madagascar" },
  { iso_alpha2: "MW", country_name: "Malawi" },
  { iso_alpha2: "MY", country_name: "Malaysia" },
  { iso_alpha2: "MV", country_name: "Maldives" },
  { iso_alpha2: "ML", country_name: "Mali" },
  { iso_alpha2: "MT", country_name: "Malta" },
  { iso_alpha2: "MH", country_name: "Marshall Islands" },
  { iso_alpha2: "MR", country_name: "Mauritania" },
  { iso_alpha2: "MU", country_name: "Mauritius" },
  { iso_alpha2: "MX", country_name: "Mexico" },
  { iso_alpha2: "FM", country_name: "Micronesia" },
  { iso_alpha2: "MD", country_name: "Moldova" },
  { iso_alpha2: "MC", country_name: "Monaco" },
  { iso_alpha2: "MN", country_name: "Mongolia" },
  { iso_alpha2: "ME", country_name: "Montenegro" },
  { iso_alpha2: "MA", country_name: "Morocco" },
  { iso_alpha2: "MZ", country_name: "Mozambique" },
  { iso_alpha2: "MM", country_name: "Myanmar" },
  { iso_alpha2: "NA", country_name: "Namibia" },
  { iso_alpha2: "NR", country_name: "Nauru" },
  { iso_alpha2: "NP", country_name: "Nepal" },
  { iso_alpha2: "NL", country_name: "Netherlands" },
  { iso_alpha2: "NZ", country_name: "New Zealand" },
  { iso_alpha2: "NI", country_name: "Nicaragua" },
  { iso_alpha2: "NE", country_name: "Niger" },
  { iso_alpha2: "NG", country_name: "Nigeria" },
  { iso_alpha2: "KP", country_name: "North Korea" },
  { iso_alpha2: "MK", country_name: "North Macedonia" },
  { iso_alpha2: "NO", country_name: "Norway" },
  { iso_alpha2: "OM", country_name: "Oman" },
  { iso_alpha2: "PK", country_name: "Pakistan" },
  { iso_alpha2: "PW", country_name: "Palau" },
  { iso_alpha2: "PA", country_name: "Panama" },
  { iso_alpha2: "PG", country_name: "Papua New Guinea" },
  { iso_alpha2: "PY", country_name: "Paraguay" },
  { iso_alpha2: "PE", country_name: "Peru" },
  { iso_alpha2: "PH", country_name: "Philippines" },
  { iso_alpha2: "PL", country_name: "Poland" },
  { iso_alpha2: "PT", country_name: "Portugal" },
  { iso_alpha2: "QA", country_name: "Qatar" },
  { iso_alpha2: "RO", country_name: "Romania" },
  { iso_alpha2: "RU", country_name: "Russia" },
  { iso_alpha2: "RW", country_name: "Rwanda" },
  { iso_alpha2: "KN", country_name: "Saint Kitts and Nevis" },
  { iso_alpha2: "LC", country_name: "Saint Lucia" },
  { iso_alpha2: "VC", country_name: "Saint Vincent and the Grenadines" },
  { iso_alpha2: "WS", country_name: "Samoa" },
  { iso_alpha2: "SM", country_name: "San Marino" },
  { iso_alpha2: "ST", country_name: "Sao Tome and Principe" },
  { iso_alpha2: "SA", country_name: "Saudi Arabia" },
  { iso_alpha2: "SN", country_name: "Senegal" },
  { iso_alpha2: "RS", country_name: "Serbia" },
  { iso_alpha2: "SC", country_name: "Seychelles" },
  { iso_alpha2: "SL", country_name: "Sierra Leone" },
  { iso_alpha2: "SG", country_name: "Singapore" },
  { iso_alpha2: "SK", country_name: "Slovakia" },
  { iso_alpha2: "SI", country_name: "Slovenia" },
  { iso_alpha2: "SB", country_name: "Solomon Islands" },
  { iso_alpha2: "SO", country_name: "Somalia" },
  { iso_alpha2: "ZA", country_name: "South Africa" },
  { iso_alpha2: "KR", country_name: "South Korea" },
  { iso_alpha2: "SS", country_name: "South Sudan" },
  { iso_alpha2: "ES", country_name: "Spain" },
  { iso_alpha2: "LK", country_name: "Sri Lanka" },
  { iso_alpha2: "SD", country_name: "Sudan" },
  { iso_alpha2: "SR", country_name: "Suriname" },
  { iso_alpha2: "SE", country_name: "Sweden" },
  { iso_alpha2: "CH", country_name: "Switzerland" },
  { iso_alpha2: "SY", country_name: "Syria" },
  { iso_alpha2: "TW", country_name: "Taiwan" },
  { iso_alpha2: "TJ", country_name: "Tajikistan" },
  { iso_alpha2: "TZ", country_name: "Tanzania" },
  { iso_alpha2: "TH", country_name: "Thailand" },
  { iso_alpha2: "TL", country_name: "Timor-Leste" },
  { iso_alpha2: "TG", country_name: "Togo" },
  { iso_alpha2: "TO", country_name: "Tonga" },
  { iso_alpha2: "TT", country_name: "Trinidad and Tobago" },
  { iso_alpha2: "TN", country_name: "Tunisia" },
  { iso_alpha2: "TR", country_name: "Turkey" },
  { iso_alpha2: "TM", country_name: "Turkmenistan" },
  { iso_alpha2: "TV", country_name: "Tuvalu" },
  { iso_alpha2: "UG", country_name: "Uganda" },
  { iso_alpha2: "UA", country_name: "Ukraine" },
  { iso_alpha2: "AE", country_name: "United Arab Emirates" },
  { iso_alpha2: "GB", country_name: "United Kingdom" },
  { iso_alpha2: "US", country_name: "United States" },
  { iso_alpha2: "UY", country_name: "Uruguay" },
  { iso_alpha2: "UZ", country_name: "Uzbekistan" },
  { iso_alpha2: "VU", country_name: "Vanuatu" },
  { iso_alpha2: "VA", country_name: "Vatican City" },
  { iso_alpha2: "VE", country_name: "Venezuela" },
  { iso_alpha2: "VN", country_name: "Vietnam" },
  { iso_alpha2: "YE", country_name: "Yemen" },
  { iso_alpha2: "ZM", country_name: "Zambia" },
  { iso_alpha2: "ZW", country_name: "Zimbabwe" },
];

export interface BookingVisaForm {
  visa_holder_name: string;
  visa_number: string;
  visa_type: number;
  issuing_country: string;
  application_requirements: string;
  validity_period: string;
  fees: string;
  currency: string;
  advance_amount_paid: string;
  processing_time: string;
  additional_notes: string;
  booking: string;
}

export interface BookingVisaEditForm extends BookingVisaForm {
  id: string;
}

export interface BookingVisa {
  id: string;
  visa_holder_name: string;
  visa_number: string;
  visa_type: number;
  issuing_country: string;
  application_requirements: string;
  validity_period: string;
  fees: string;
  currency: string;
  advance_amount_paid: string;
  processing_time: string;
  additional_notes: string;
  documents: Record<string, string>;
  created: string;
  updated: string;
  booking: string;
}

export interface InsuranceTraveler {
  name: string;
  phone: string;
  date_of_birth: string;
}

export interface BookingInsuranceForm {
  insurance_provider: string;
  policy_number: string;
  insurance_type: number;
  traveler_info: InsuranceTraveler[];
  coverage_amount: string;
  premium_amount: string;
  premium_amount_n_currency: string;
  advance_amount_paid: string;
  effective_date: string;
  expiry_date: string;
  policy_terms_conditions: string;
  additional_information: string;
  booking_id: string;
}

export interface BookingInsuranceEditForm extends BookingInsuranceForm {
  id: string;
}

export interface BookingInsurance {
  id: string;
  insurance_provider: { id: string; provider_name: string };
  policy_number: string;
  insurance_type: number;
  traveler_info: InsuranceTraveler[];
  coverage_amount: string;
  premium_amount: string;
  premium_amount_n_currency: string;
  advance_amount_paid: string;
  effective_date: string;
  expiry_date: string;
  policy_terms_conditions: string;
  additional_information: string;
  attachments: Record<string, string>;
  created: string;
  updated: string;
  booking_id: string;
}

export interface BookingTransaction {
  id: string;
  // amount_received: number;
  amount: number;
  notes: string;
  transaction_type?: TransactionType;
  partner_type?: string;
  agent?: TravelAgent;
  cabvendor?: CabVendor;
  driver?: Driver;
  hotel?: Hotel;
  taxi?: Taxi;
  airline?: Airline;
  booking_flight?: BookingFlight;
  flight_airline_name?: string;
  cruise_line?: CruiseLine;
  booking_passport?: BookingPassport;
  booking_visa?: BookingVisa;
  booking_insurance?: BookingInsurance;
  // partner_type?: PartnerType;
  created_date: string;
  updated_date: string;
  booking: string;
  company: string;
  user: string;
}

export interface BookingData {
  id: string;
  customer_name: string;
  customer_number: number;
  company: string;
  user: UserData;
  email: string | null;
  booking_date: string;
  arrival_date: string;
  departure_date: string;
  total_pax: number | null;
  total_children: string | null;
  total_amount: number;
  amount_received: number | null;
  next_payment_date: string | null;
  agent_commission: string | null;
  flight_tickets: string | null;
  profit: string;
  created: string;
  updated: string;
  status: number;
  gain_margin: number;
  gain_margin_colour: GainMargin;
  bookingcab_set: BookingCab[];
  booking_hotels: BookingHotel[];
  booking_flights: BookingFlight[];
  booking_cruises: BookingCruise[];
  booking_passports: BookingPassport[];
  booking_visas: BookingVisa[];
  booking_insurances: BookingInsurance[];
  // travel_agent_id: string;
  travel_agent: TravelAgent;
  booking_transactions: BookingTransaction[];
  customer_address: string;
  customer_gstn: string;
  notes: string;
}

export interface BookingsTodayAndLatest {
  latest_ten_bookings: BookingData[];
  today_bookings: BookingData[];
}

export interface BookingsState {
  data?: Pagination<BookingData>;
  // data?: BookingData[];
  status: API_STATUS;
  view: {
    data?: BookingData;
    status: API_STATUS;
  };
}

const initialState: BookingsState = {
  data: {
    count: 0,
    next: null,
    previous: null,
    results: [],
  },
  status: "idle",
  view: {
    data: undefined,
    status: "idle",
  },
};

export const bookingsSlice = createSlice({
  name: "bookings",
  initialState,
  reducers: {
    resetBookingView(state) {
      state.view.status = "idle";
    },
    resetBookingList(state) {
      state.status = "idle";
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchBookings.pending, (state, action) => {
      state.status = "pending";
    });
    builder.addCase(fetchBookings.fulfilled, (state, action) => {
      state.status = "success";
      state.data = action.payload;
    });
    builder.addCase(fetchBookings.rejected, (state, action) => {
      state.status = "error";
    });
    builder.addCase(addBooking.fulfilled, (state, action) => {
      state.status = "idle";
    });
    builder.addCase(editBooking.fulfilled, (state, action) => {
      state.status = "idle";
      state.view.status = "idle";
    });
    builder.addCase(addHotelBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(editHotelBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(addCabBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(editCabBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(addBookingTransaction.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(fetchBookingDetail.fulfilled, (state, action) => {
      state.view.data = action.payload;
      state.view.status = "success";
    });
    builder.addCase(fetchBookingDetail.pending, (state, action) => {
      state.view.status = "pending";
    });
    builder.addCase(fetchBookingDetail.rejected, (state, action) => {
      state.view.status = "error";
    });
    builder.addCase(deleteHotelBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(deleteCabBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(addFlightBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(editFlightBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(deleteFlightBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(addCruiseBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(editCruiseBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(deleteCruiseBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(addPassportBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(editPassportBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(deletePassportBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(addVisaBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(editVisaBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(deleteVisaBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(addInsuranceBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(editInsuranceBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
    builder.addCase(deleteInsuranceBooking.fulfilled, (state, action) => {
      state.view.status = "idle";
      state.status = "idle";
    });
  },
});

export interface BookingSearchOption {
  // booking_id_: string
  filter_type?: string;
  start_date?: string;
  end_date?: string;
  driver_id?: string;
  taxi_id?: string;
  travel_agent_id?: string;
  cab_vendor_id?: string;
  hotel_id?: string;
  user_id?: string;
  gain_margin_colour?: "green" | "red";
  keyword?: string;
  status?: number;
}

export const fetchPendingPaymentBookings = createAsyncThunk<
  BookingData[],
  void,
  { state: RootState }
>("bookings/pendingPayment", async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      PartnerAPIResponseCover<BookingData[]>,
      AxiosResponse<PartnerAPIResponseCover<BookingData[]>>,
      BookingSearchOption
    >(`ReportsApi/pending-payment-report/?format=json`);
    // console.log(response.data);
    return thunkAPI.fulfillWithValue(response.data.data);
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const fetchTodayBookings = createAsyncThunk<
  BookingsTodayAndLatest,
  void,
  { state: RootState }
>("bookings/today", async (_, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      PartnerAPIResponseCover<BookingsTodayAndLatest>,
      AxiosResponse<PartnerAPIResponseCover<BookingsTodayAndLatest>>,
      BookingSearchOption
    >(`ReportsApi/today-booking-report/?format=json`);
    // console.log(response.data);
    return thunkAPI.fulfillWithValue(response.data.data);
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const fetchBookings = createAsyncThunk<
  Pagination<BookingData>,
  { page: number; filter?: BookingSearchOption; order?: string; by?: string },
  { state: RootState }
>("bookings/fetch", async ({ page = 1, filter = {}, order, by }, thunkAPI) => {
  try {
    const sortQuery =
      order && by ? `&order=${encodeURIComponent(order)}&by=${encodeURIComponent(by)}` : "";
    const response = await axiosInstance.post<
      PartnerAPIResponseCover<Pagination<BookingData>>,
      AxiosResponse<PartnerAPIResponseCover<Pagination<BookingData>>>,
      BookingSearchOption
    >(
      `BookingApi/list-bookings/?limit=${DATA_LIMIT}&offset=${
        DATA_LIMIT * (page - 1)
      }&format=json${sortQuery}`,
      filter
    );
    // console.log(response.data);
    return thunkAPI.fulfillWithValue(response.data.data);
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const downloadBookingVoucher = createAsyncThunk<
  string,
  string,
  { state: RootState }
>("bookings/fetch", async (id, thunkAPI) => {
  try {
    if (!id) {
      throw new Error("id missing");
    }
    const response = await axiosInstance.get<
      Blob
    >(`CompanySettings/booking-voucher-option-1/?booking_id=${id}`, {responseType: 'blob'});
    const href = window.URL.createObjectURL(response.data)
    return thunkAPI.fulfillWithValue(href);
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const fetchBookingsMaster = createAsyncThunk<
  Pagination<BookingData>,
  { page: number; filter?: BookingSearchOption, signal?: AbortSignal },
  { state: RootState }
>("bookings/master-fetch", async ({ page = 1, filter = {}, signal }, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      PartnerAPIResponseCover<Pagination<BookingData>>,
      AxiosResponse<PartnerAPIResponseCover<Pagination<BookingData>>>,
      BookingSearchOption
    >(
      `BookingApi/list-bookings/?limit=${DATA_LIMIT}&offset=${
        DATA_LIMIT * (page - 1)
      }&format=json`,
      filter,
      { signal }
    );
    // console.log(response.data);
    return thunkAPI.fulfillWithValue(response.data.data);
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const fetchBookingsByStatus = createAsyncThunk<
  BookingData[],
  { status: BOOKING_STATUS; page: number },
  { state: RootState }
>("bookings/status/fetch", async ({ status, page }, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      PartnerAPIResponseCover<Pagination<BookingData>>,
      AxiosResponse<PartnerAPIResponseCover<Pagination<BookingData>>>
    >(
      `BookingApi/list-bookings/?limit=${DATA_LIMIT}&offset=${
        DATA_LIMIT * (page - 1)
      }&format=json`,
      { status }
    );
    // console.log(response.data);
    return thunkAPI.fulfillWithValue(response.data.data.results);
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const fetchBookingDetail = createAsyncThunk<
  BookingData,
  string | undefined,
  { state: RootState }
>("booking/fetch", async (id, thunkAPI) => {
  try {
    if (!id) {
      throw new Error("id missing");
    }
    const response = await axiosInstance.post<
      PartnerAPIResponseCover<Pagination<BookingData>>,
      AxiosResponse<PartnerAPIResponseCover<Pagination<BookingData>>>
    >("BookingApi/list-bookings/?format=json", { booking_id: id });
    // console.log(response.data);
    if (response?.data?.data.results.length === 0) {
      return thunkAPI.rejectWithValue(false);
    }
    return thunkAPI.fulfillWithValue(response?.data?.data?.results?.[0]);
  } catch (e: unknown) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

// export const updateUser = createAsyncThunk(
//   "bookings/update",
//   async (data: UserEditDataForm, thunkAPI) => {
//     try {
//       const response = await axiosInstance.post<
//         APIResponseCover<Record<never, never>>,
//         AxiosResponse<APIResponseCover<Record<never, never>>, UserEditDataForm>,
//         UserEditDataForm
//       >("UsersApi/update-user/?format=json", {
//         ...data,
//         token: thunkAPI.getState().auth.data.token,
//       });
//       console.log(response.data);
//       return thunkAPI.fulfillWithValue({ status: "pending" });
//     } catch (e) {
//       if (e instanceof AxiosError) {
//         throw new Error(readAPIErrorMessage(e));
//       } else {
//         throw new Error(e.message);
//       }
//       // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
//       // console.log(e.response.data.data.data[0])
//     }
//   }
// );

// export const viewUser = createAsyncThunk(
//   "bookings/view",
//   async (data: UserViewData, thunkAPI) => {
//     try {
//       const response = await axiosInstance.post<
//         APIResponseCover<Record<never, never>>,
//         AxiosResponse<APIResponseCover<Record<never, never>>, UserViewData>,
//         UserViewData
//       >("UsersApi/view-user/?format=json", {
//         ...data,
//         token: thunkAPI.getState().auth.data.token,
//       });
//       console.log(response.data);
//       return thunkAPI.fulfillWithValue({ status: "pending" });
//     } catch (e) {
//       if (e instanceof AxiosError) {
//         throw new Error(readAPIErrorMessage(e));
//       } else {
//         throw new Error(e.message);
//       }
//       // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
//       // console.log(e.response.data.data.data[0])
//     }
//   }
// );

export const editBooking = createAsyncThunk<
  { status: string },
  BookingDataEditForm,
  { state: RootState }
>("bookings/edit", async (data: BookingDataEditForm, thunkAPI) => {
  try {
    const response = await axiosInstance.put<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<
        APIResponseCover<Record<never, never>>,
        BookingDataEditForm
      >,
      BookingDataEditForm
    >("BookingApi/booking/?format=json", {
      ...data,
    });
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const addBooking = createAsyncThunk<
  { status: string; data: string },
  BookingDataForm,
  { state: RootState }
>("bookings/add", async (data: BookingDataForm, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      APIResponseCover<string>,
      AxiosResponse<APIResponseCover<string>, BookingDataForm>,
      BookingDataForm
    >("BookingApi/booking/?format=json", {
      // >("BookingApi/add-booking/?format=json", {
      ...data,
    });
    return thunkAPI.fulfillWithValue({
      status: "idle",
      data: response.data.data,
    });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const addHotelBooking = createAsyncThunk<
  { status: string },
  BookingHotelForm,
  { state: RootState }
>("bookings/hotel", async (data: BookingHotelForm, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>, BookingHotelForm>,
      BookingHotelForm
    >("BookingApi/booking-hotel/?format=json", {
      ...data,
    });
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const editHotelBooking = createAsyncThunk<
  { status: string },
  BookingHotelEditForm,
  { state: RootState }
>("bookings/hotelEdit", async (data: BookingHotelEditForm, thunkAPI) => {
  try {
    const response = await axiosInstance.put<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<
        APIResponseCover<Record<never, never>>,
        BookingHotelEditForm
      >,
      BookingHotelEditForm
    >("BookingApi/booking-hotel/?format=json", {
      ...data,
    });
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const deleteHotelBooking = createAsyncThunk<
  { status: string },
  string,
  { state: RootState }
>("bookings/hotelDelete", async (hotel_id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<
        APIResponseCover<Record<never, never>>,
        BookingHotelEditForm
      >,
      BookingHotelEditForm
    >(`BookingApi/booking-hotel/${hotel_id}?format=json`);
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const deleteCabBooking = createAsyncThunk<
  { status: string },
  string,
  { state: RootState }
>("bookings/cabDelete", async (hotel_id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<
        APIResponseCover<Record<never, never>>,
        BookingHotelEditForm
      >,
      BookingHotelEditForm
    >(`BookingApi/booking-cab/${hotel_id}?format=json`);
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const addCabBooking = createAsyncThunk<
  { status: string },
  BookingCabForm,
  { state: RootState }
>("bookings/cab", async (data: BookingCabForm, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>, BookingCabForm>,
      BookingCabForm
    >("BookingApi/booking-cab/?format=json", {
      ...data,
    });
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
      // throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const editCabBooking = createAsyncThunk<
  { status: string },
  BookingCabEditForm,
  { state: RootState }
>("bookings/cabEdit", async (data: BookingCabEditForm, thunkAPI) => {
  try {
    const response = await axiosInstance.put<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>, BookingCabEditForm>,
      BookingCabEditForm
    >("BookingApi/booking-cab/?format=json", {
      ...data,
    });
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const addBookingTransaction = createAsyncThunk<
  { status: string },
  BookingTransactForm,
  { state: RootState }
>("bookings/addTransaction", async (data: BookingTransactForm, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<
        APIResponseCover<Record<never, never>>,
        BookingTransactForm
      >,
      BookingTransactForm
    >("BookingApi/add-booking-transaction/?format=json", {
      ...data,
    });
    // console.log(response.data);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
    // return thunkAPI.rejectWithValue(e.response.data.data.data[0]);
    // console.log(e.response.data.data.data[0])
  }
});

export const addFlightBooking = createAsyncThunk<
  { status: string },
  BookingFlightForm,
  { state: RootState }
>("bookings/flight", async (data: BookingFlightForm, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>, BookingFlightForm>,
      BookingFlightForm
    >("BookingApi/booking-flight/?format=json", {
      ...data,
    });
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const editFlightBooking = createAsyncThunk<
  { status: string },
  BookingFlightEditForm,
  { state: RootState }
>("bookings/flightEdit", async (data: BookingFlightEditForm, thunkAPI) => {
  try {
    const response = await axiosInstance.put<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<
        APIResponseCover<Record<never, never>>,
        BookingFlightEditForm
      >,
      BookingFlightEditForm
    >("BookingApi/booking-flight/?format=json", {
      ...data,
    });
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const deleteFlightBooking = createAsyncThunk<
  { status: string },
  string,
  { state: RootState }
>("bookings/flightDelete", async (flight_id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>>
    >(`BookingApi/booking-flight/${flight_id}?format=json`);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const searchAirlinesRef = createAsyncThunk<
  AirlineRef[],
  string,
  { state: RootState }
>("bookings/searchAirlinesRef", async (keyword, thunkAPI) => {
  try {
    const response = await axiosInstance.get<
      APIResponseCover<AirlineRef[]>,
      AxiosResponse<APIResponseCover<AirlineRef[]>>
    >(`partners/airlines_ref/search/?keyword=${encodeURIComponent(keyword)}&format=json`);
    return thunkAPI.fulfillWithValue(response.data.data);
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const addCruiseBooking = createAsyncThunk<
  { status: string },
  BookingCruiseForm,
  { state: RootState }
>("bookings/cruise", async (data: BookingCruiseForm, thunkAPI) => {
  try {
    const response = await axiosInstance.post<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>, BookingCruiseForm>,
      BookingCruiseForm
    >("BookingApi/booking-cruise/?format=json", {
      ...data,
    });
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const editCruiseBooking = createAsyncThunk<
  { status: string },
  BookingCruiseEditForm,
  { state: RootState }
>("bookings/cruiseEdit", async (data: BookingCruiseEditForm, thunkAPI) => {
  try {
    const response = await axiosInstance.put<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<
        APIResponseCover<Record<never, never>>,
        BookingCruiseEditForm
      >,
      BookingCruiseEditForm
    >("BookingApi/booking-cruise/?format=json", {
      ...data,
    });
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const deleteCruiseBooking = createAsyncThunk<
  { status: string },
  string,
  { state: RootState }
>("bookings/cruiseDelete", async (cruise_id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>>
    >(`BookingApi/booking-cruise/${cruise_id}?format=json`);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const sanitizeFileName = (name: string): string => {
  return name
    .replace(/\s+/g, "_")
    .replace(/[^a-zA-Z0-9\-_.]/g, "");
};

export const addPassportBooking = createAsyncThunk<
  { status: string },
  { form: BookingPassportForm; files: File[] },
  { state: RootState }
>("bookings/passport", async ({ form, files }, thunkAPI) => {
  try {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, String(value));
      }
    });
    files.forEach((file) => {
      const sanitizedName = sanitizeFileName(file.name);
      formData.append("files", file, sanitizedName);
    });
    await axiosInstance.post(
      "BookingApi/booking-passport/?format=json",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const editPassportBooking = createAsyncThunk<
  { status: string },
  { form: BookingPassportEditForm; files: File[] },
  { state: RootState }
>("bookings/passportEdit", async ({ form, files }, thunkAPI) => {
  try {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, String(value));
      }
    });
    files.forEach((file) => {
      const sanitizedName = sanitizeFileName(file.name);
      formData.append("files", file, sanitizedName);
    });
    await axiosInstance.put(
      "BookingApi/booking-passport/?format=json",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const deletePassportBooking = createAsyncThunk<
  { status: string },
  string,
  { state: RootState }
>("bookings/passportDelete", async (passport_id, thunkAPI) => {
  try {
    await axiosInstance.delete<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>>
    >(`BookingApi/booking-passport/${passport_id}?format=json`);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const downloadPassportAttachment = createAsyncThunk<
  string,
  { booking_id: string; passport_id: string; document_id: string },
  { state: RootState }
>(
  "bookings/passportDownload",
  async ({ booking_id, passport_id, document_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.get<Blob>(
        `BookingApi/booking-passport-download/?booking_id=${booking_id}&passport_id=${passport_id}&document_id=${encodeURIComponent(document_id)}`,
        { responseType: "blob" }
      );
      const href = window.URL.createObjectURL(response.data);
      return thunkAPI.fulfillWithValue(href);
    } catch (e) {
      if (e instanceof AxiosError) {
        throw new Error(readAPIErrorMessage(e));
      } else if (e instanceof Error) {
        throw new Error(e.message);
      }
      return thunkAPI.rejectWithValue(false);
    }
  }
);

export const addVisaBooking = createAsyncThunk<
  { status: string },
  { form: BookingVisaForm; files: File[] },
  { state: RootState }
>("bookings/visa", async ({ form, files }, thunkAPI) => {
  try {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, String(value));
      }
    });
    files.forEach((file) => {
      const sanitizedName = sanitizeFileName(file.name);
      formData.append("files", file, sanitizedName);
    });
    await axiosInstance.post(
      "BookingApi/booking-visa/?format=json",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const editVisaBooking = createAsyncThunk<
  { status: string },
  { form: BookingVisaEditForm; files: File[] },
  { state: RootState }
>("bookings/visaEdit", async ({ form, files }, thunkAPI) => {
  try {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        formData.append(key, String(value));
      }
    });
    files.forEach((file) => {
      const sanitizedName = sanitizeFileName(file.name);
      formData.append("files", file, sanitizedName);
    });
    await axiosInstance.put(
      "BookingApi/booking-visa/?format=json",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const deleteVisaBooking = createAsyncThunk<
  { status: string },
  string,
  { state: RootState }
>("bookings/visaDelete", async (visa_id, thunkAPI) => {
  try {
    await axiosInstance.delete<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>>
    >(`BookingApi/booking-visa/${visa_id}?format=json`);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const downloadVisaDocument = createAsyncThunk<
  string,
  { booking_id: string; visa_id: string; document_id: string },
  { state: RootState }
>(
  "bookings/visaDownload",
  async ({ booking_id, visa_id, document_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.get<Blob>(
        `BookingApi/booking-visa-download/?booking_id=${booking_id}&visa_id=${visa_id}&document_id=${encodeURIComponent(document_id)}`,
        { responseType: "blob" }
      );
      const href = window.URL.createObjectURL(response.data);
      return thunkAPI.fulfillWithValue(href);
    } catch (e) {
      if (e instanceof AxiosError) {
        throw new Error(readAPIErrorMessage(e));
      } else if (e instanceof Error) {
        throw new Error(e.message);
      }
      return thunkAPI.rejectWithValue(false);
    }
  }
);

export const addInsuranceBooking = createAsyncThunk<
  { status: string },
  { form: BookingInsuranceForm; files: File[] },
  { state: RootState }
>("bookings/insurance", async ({ form, files }, thunkAPI) => {
  try {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (key === "traveler_info") {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, String(value));
        }
      }
    });
    files.forEach((file) => {
      const sanitizedName = sanitizeFileName(file.name);
      formData.append("files", file, sanitizedName);
    });
    await axiosInstance.post(
      "BookingApi/booking-insurance/?format=json",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const editInsuranceBooking = createAsyncThunk<
  { status: string },
  { form: BookingInsuranceEditForm; files: File[] },
  { state: RootState }
>("bookings/insuranceEdit", async ({ form, files }, thunkAPI) => {
  try {
    const formData = new FormData();
    Object.entries(form).forEach(([key, value]) => {
      if (value !== null && value !== undefined) {
        if (key === "traveler_info") {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, String(value));
        }
      }
    });
    files.forEach((file) => {
      const sanitizedName = sanitizeFileName(file.name);
      formData.append("files", file, sanitizedName);
    });
    await axiosInstance.put(
      "BookingApi/booking-insurance/?format=json",
      formData,
      { headers: { "Content-Type": "multipart/form-data" } }
    );
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throwErrApi(e);
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const deleteInsuranceBooking = createAsyncThunk<
  { status: string },
  string,
  { state: RootState }
>("bookings/insuranceDelete", async (insurance_id, thunkAPI) => {
  try {
    await axiosInstance.delete<
      APIResponseCover<Record<never, never>>,
      AxiosResponse<APIResponseCover<Record<never, never>>>
    >(`BookingApi/booking-insurance/${insurance_id}?format=json`);
    return thunkAPI.fulfillWithValue({ status: "idle" });
  } catch (e) {
    if (e instanceof AxiosError) {
      throw new Error(readAPIErrorMessage(e));
    } else if (e instanceof Error) {
      throw new Error(e.message);
    }
    return thunkAPI.rejectWithValue(false);
  }
});

export const downloadInsuranceDocument = createAsyncThunk<
  string,
  { booking_id: string; insurance_id: string; document_id: string },
  { state: RootState }
>(
  "bookings/insuranceDownload",
  async ({ booking_id, insurance_id, document_id }, thunkAPI) => {
    try {
      const response = await axiosInstance.get<Blob>(
        `BookingApi/booking-insurance-download/?booking_id=${booking_id}&insurance_id=${insurance_id}&document_id=${encodeURIComponent(document_id)}`,
        { responseType: "blob" }
      );
      const href = window.URL.createObjectURL(response.data);
      return thunkAPI.fulfillWithValue(href);
    } catch (e) {
      if (e instanceof AxiosError) {
        throw new Error(readAPIErrorMessage(e));
      } else if (e instanceof Error) {
        throw new Error(e.message);
      }
      return thunkAPI.rejectWithValue(false);
    }
  }
);

export const { resetBookingView, resetBookingList } = bookingsSlice.actions;

export default bookingsSlice.reducer;
